import { State } from './index';

/**
 * Update flags for PriceSection container
 */
export const getUpdateFlags = (state: State, oldState: State) => {
    const avcChanged = state.avcResult !== oldState.avcResult;
    const tariffChanged = Boolean(state.selectedTariff && state.selectedTariff !== oldState.selectedTariff);
    const gigakombiChanged = state.gigakombi !== oldState.gigakombi;
    const errorChanged = state.backendDown !== oldState.backendDown;
    const userInfoChanged = state.userInfo !== oldState.userInfo;
    const preMarketingChanged = state.preMarketingType !== oldState.preMarketingType;
    const discountChanged = state.ff !== oldState.ff || state.gigakombi !== oldState.gigakombi;

    return {
        gigakombi: gigakombiChanged,
        price: (tariffChanged || avcChanged || preMarketingChanged || discountChanged)
            && state.selectedTariff,
        button: tariffChanged || avcChanged || gigakombiChanged || userInfoChanged,
        discount: tariffChanged,
        error: errorChanged,
    };
};
